import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const OutsourcingProvider4 = props => (
    <section id="outsourcing-provider-section4" className="white-bg my pt-5">
        <div className='black-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 fw-600 mb-5">{props.t('services:outsourcingProvider:section-4.title')}</h2>
            {/* Sub-item 1 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5n fw-600 m-0'>{props.t('services:outsourcingProvider:section-4.1.title')}</h3>
                </div>
                <p><Trans i18nKey="services:outsourcingProvider:section-4.1.text" components={{ br: <br /> }} /></p>
            </div>
            {/* Sub-item 2 — with subtitles */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingProvider:section-4.2.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingProvider:section-4.2.text')}</p>
                {[1, 2, 3].map(item => (
                    <React.Fragment key={item}>
                        <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingProvider:section-4.2.' + item + '.title')}</h4>
                        <p>{props.t('services:outsourcingProvider:section-4.2.' + item + '.text')}</p>
                    </React.Fragment>
                ))}
            </div>
            <p className='m-0'>{props.t('services:outsourcingProvider:section-4.text')}</p>
        </Container>
    </section>
);

export default OutsourcingProvider4;
